export default __webpack_public_path__ + "static/media/TawnyLovelace.f28a24d1.png";